
import ModalView from 'common-views/ModalView';
import template  from 'dashboard/forms/modal/migrate-form.ejs';
import $ from 'jquery';
import constants from 'Constants';

class MigrateFormModal extends ModalView {

    get selectedMigration(){
        return this._selectedMigration;
    }

    set selectedMigration(value) {
        this._selectedMigration = value;
    }

    initialize(){
        super.initialize();
        this.template = template;
        this.selectedMigration = constants.IMPORT_INITIAL_VALUE;
    }

    render(){
        return new Promise((resolve, reject) => {
            const settings = this.settings;
            settings.width = 400;
            settings.buttons = [
                {
                    text: 'OK',
                    disabled: true,
                    'class':'migrateFormOk',
                    click: () => {
                        resolve(this.processMigration());
                        this.closeModal();
                    }
                },
                {
                    text: 'Cancel',
                    click: () => {
                        resolve('Unauthorized');
                        this.closeModal();
                    }
                }
            ];

            settings.open = () => {
                this.addVersionsToSelect();
                this.bindEvents();
                // Default first rb to checked, enable OK
                $(`input.action-selector[value='i']`).prop("checked", true);
                this.enableOK();
            };

            if(this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }
            super.render();

        });
    }

    processMigration(){
        const result = {selection: this.selectedMigration, options: null};
        switch(this.selectedMigration){
            case 'i':
                //import for design
                break;
            case 'n':
                // Export for design
                this.enableVersionPicker();
                result.options = $(constants.DIALOG_ID + ' .version').val();
                break;
            case 'x':
                result.options = this.getExportResponseOptionsB();
                break;
            case 's':
                result.options = this.getExportResponseOptions();
                break;
        }

        return result;
    }

    getExportResponseOptions(){
        const options = [];
        options.push($('input[name=separator]:checked').val());
        $('input[name=option-a]:checked').each(function() {
            options.push($(this).val());
        });
        $('input[name=option-b]:checked').each(function() {
            options.push($(this).val());
        });
        return options;
    }

    getExportResponseOptionsB(){
        const options = [];
        $('input[name=option-b]:checked').each(function() {
            options.push($(this).val());
        });
        return options;
    }

    disableRestricted(){
        $(constants.DIALOG_ID + ' .version').prop('disabled', true);
        $(constants.DIALOG_ID + ' .separator').prop('disabled', true);
        $(constants.DIALOG_ID + ' .export-option-a').prop('disabled', true);
        $(constants.DIALOG_ID + ' .export-option-b').prop('disabled', true);
    }

    enableExportOptions(){
        $(constants.DIALOG_ID + ' .separator').prop('disabled', false);
        $(constants.DIALOG_ID + ' .export-option-a').prop('disabled', false);
        $(constants.DIALOG_ID + ' .export-option-b').prop('disabled', false);
    }

    enableExportOptionsB(){
        $(constants.DIALOG_ID + ' .export-option-b').prop('disabled', false);
    }

    enableVersionPicker(){
        $(constants.DIALOG_ID + ' .version').prop('disabled', false);
    }

    addVersionsToSelect(){
        $('#versions').find('option').remove();
        this.model.get('versions').map( v => {
            $('#versions').append('<option value="' + v + '">' + v + '</option>')
        });
    }

    bindEvents(){
        $(`${constants.DIALOG_ID} input.transfer-ownership`).on("click", e => {
            const newVal = e.currentTarget.value;
            this.selectedMigration = constants.DASHBOARD_XFER_OWNERSHIP;
        });

        $(`${constants.DIALOG_ID} input.action-selector`).on("click",(e)=>{
            const newVal = e.currentTarget.value;

            if(newVal !== this.selectedMigration){
                this.selectedMigration = newVal;
                this.enableOK();
                this.selectMigrationType(newVal);
            }
        });

        $(`${constants.DIALOG_ID} input.export-option-b`).on("click",(e)=>{
            const newVal = e.currentTarget.value;
            const checked = e.currentTarget.checked;
            const $selector = $(`input.export-option-b[value='z']`);

            // If we include attachments, should be a zip
            if(newVal === 'a' && checked){
                $selector.prop('checked', true);
                $selector.prop('disabled', true);
            } else {
                $selector.prop('disabled', false);
            }
        });
    }

    enableOK(){
        $('button.migrateFormOk').button("enable")
    }

    selectMigrationType(newVal){
        this.disableRestricted();

        switch(newVal) {
            case 'x':
                this.enableExportOptionsB();
                break;
            case 's':
                this.enableExportOptions();
                break;
            case 'n':
                this.enableVersionPicker();
                break;
        }
    }
}

export default MigrateFormModal;